export default "__VITE_ASSET__CGpC$pY3__"